import mapValues from "lodash/mapValues";
import teamRuleFactory from "./teamValidationRules";

export const VALIDATED_TEAM_FIELDS = [
	"name",
	"memberBeingAdded",
];

export function getPlainFromValidatableTeam( { team, } ) {
	const payload = mapValues( team, v => {
		return v.value;
	} );
	return payload;
}

export function getPayloadFromValidatableTeam( { team, } ) {
	const payload = mapValues( team, v => {
		return v.value;
	} );
	return payload;
}

export function teamValidationFactory( { i18n, } ) {
	const teamValidationRules = teamRuleFactory( { i18n, } );

	function applyTeamValidation( team, fields ) {
		teamValidationRules
			.filter( r => fields.includes( r.field ) )
			.forEach( ( { field, rule, } ) => {
				const validationError = rule( team );
				if ( validationError ) {
					team[ field ].validationErrors.push( validationError );
				}
			} );
		return team;
	}

	return {
		applyTeamValidation,
	};
}
